import { CircularProgress, Dialog, DialogActions, DialogTitle } from "@mui/material";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "../../context/toast-context";
import { ManagerService } from "../../services/manager-service";
import { Button } from "@mui/material";

interface DeleteManagerProps {
    managerId: number;
    deleteManager: (managerId: number) => void;
  }
  
  export function DeleteManager({ managerId, deleteManager }: DeleteManagerProps) {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const managerService = new ManagerService();
    const { showToast } = useToast();
  
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
  
    const handleDelete = () => {
      setLoading(true);
      managerService.deleteManager(
        managerId,
        () => {
          setLoading(false);
          deleteManager(managerId);
          handleClose();
          showToast(t("managers.delete.success"), "success");
        },
        (error: string) => {
          setLoading(false);
          handleClose();
          showToast(error, "error");
        }
      );
    };
  
    return (
      <>
        <Button
          title={t("managers.delete.label")}
          onClick={handleClickOpen}
          sx={{
            margin: 0,
            minWidth: "fit-content",
            background: "transparent",
            border: "1px solid #EF0BB8",
            borderRadius: "50%",
            color: "#EF0BB8",
            textTransform: "none",
            fontFamily: "Montserrat",
            fontWeight: 300,
            width: "2.5rem",
            height: "2.5rem",
          }}
        >
          <svg
            fill="#EF0BB8"
            width="16"
            height="16"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m19.587 16.001 6.096 6.096a1.015 1.015 0 0 1 0 1.435l-2.151 2.151a1.015 1.015 0 0 1-1.435 0L16 19.587l-6.097 6.096a1.014 1.014 0 0 1-1.434 0l-2.152-2.151a1.015 1.015 0 0 1 0-1.435l6.097-6.096-6.097-6.097a1.015 1.015 0 0 1 0-1.435L8.47 6.318a1.014 1.014 0 0 1 1.434 0L16 12.415l6.097-6.097a1.015 1.015 0 0 1 1.435 0l2.151 2.152a1.015 1.015 0 0 1 0 1.435l-6.096 6.096z" />
          </svg>
        </Button>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby={t("managers.delete.label")}
          aria-describedby={t("managers.delete.label")}
        >
          <DialogTitle
            sx={{
              padding: "20px 24px",
              fontWeight: 400,
              fontSize: "16px",
              borderRadius: "30px",
              "&.MuiDialogTitle-root": {
                fontFamily: "Montserrat",
              },
            }}
            id="delete-manager"
          >
            {t("managers.delete.title")}
          </DialogTitle>
          <DialogActions>
            <Button
              sx={{
                fontFamily: "Montserrat",
                color: "#000",
                fontSize: "0.875rem",
                textTransform: "capitalize",
                fontWeight: 300,
              }}
              onClick={handleClose}
              color="inherit"
              disabled={loading}
            >
              {t("managers.delete.cancel")}
            </Button>
            <Button
              sx={{
                fontFamily: "Montserrat",
                backgroundColor: "#E60032",
                color: "#fff",
                fontSize: "0.875rem",
                textTransform: "capitalize",
                fontWeight: 300,
                width: "90px",
                "&.Mui-disabled": {
                  opacity: "40%",
                  color: "#fff",
                },
              }}
              onClick={handleDelete}
              disabled={loading}
            >
              {!loading ? (
                t("managers.delete.confirm")
              ) : (
                <CircularProgress
                  sx={{
                    color: "#fff",
                  }}
                  size="1.5rem"
                  className="animate-spin "
                />
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
  